import { config } from '@/config'
import { getRequestOptions } from '@/utils/auth-headers'
import { authService } from '@/services/AuthService'

export const balanceService = {
  getCurrentUserBalance
}

function getCurrentUserBalance () {
  return fetch(config.api.balance.user, getRequestOptions()).then(authService.handleResponse)
}
